import { createContext, useContext } from 'react';

type ContextType = {
    availableMetrics: AvailableMetricT[] | null;
    setAvailableMetrics: DispatchState<AvailableMetricT[] | null>;
    availableDimensions: AvailableDimensionT[] | null;
    setAvailableDimensions: DispatchState<AvailableDimensionT[] | null>;
    availableFilters: AvailableElementT[] | null;
    setAvailableFilters: DispatchState<AvailableElementT[] | null>;
};

const initialContext: ContextType = {
    availableMetrics: null,
    setAvailableMetrics: () => null,
    availableDimensions: null,
    setAvailableDimensions: () => null,
    availableFilters: null,
    setAvailableFilters: () => null,
};

export const AlertSentenceContext = createContext<ContextType>(initialContext);

export const useAlertSentence = () => useContext(AlertSentenceContext);
